import { numberOrZero } from "@/utils/utils";
import { Button, Card, Col, Empty, Flex, Row, Space } from "antd";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { useGetDashboardStatistics } from "../../../../../common/api/queries";
import AntIcon from "../../../../../common/components/icons/AntIcon";
import { percentageChange } from "../../../utils";
import { TrendIndicator } from "../statisticsextended/components/common/TrendIndicator";
import styles from "./DashboardStatisticsWidget.module.scss";

export const DashboardStatisticsWidget = () => {
  const { t } = useTranslation();

  const { data, isLoading } = useGetDashboardStatistics();

  const clientsStatChange = percentageChange(
    numberOrZero(data?.clientsCount),
    numberOrZero(data?.previousMonthClientsCount),
  );

  const contractsStatChange = percentageChange(
    numberOrZero(data?.contractsCount),
    numberOrZero(data?.previousMonthContractsCount),
  );

  const agentsStatChange = percentageChange(
    numberOrZero(data?.agentsCount),
    numberOrZero(data?.previousMonthAgentsCount),
  );

  return (
    <Card
      style={{ height: "100%", borderRadius: 18 }}
      styles={{ body: { height: "100%" } }}
      size="small"
      loading={isLoading}
    >
      {data ? (
        <Row gutter={24} className={styles.body}>
          <Col span={8} className={styles.border}>
            <Flex vertical justify="center" style={{ height: "100%" }}>
              <Space align="start">
                <Button
                  className={styles.labelIcon}
                  variant="filled"
                  color="volcano"
                  icon={<AntIcon className={styles.icon} type="team" />}
                />

                <div>
                  <Flex className={styles.labelWrapper} align="center">
                    <span className={styles.label}>{t("dashboard.statistics.clientsCount")}</span>

                    <div>
                      <TrendIndicator value={clientsStatChange} />
                    </div>
                  </Flex>

                  <div>
                    <CountUp
                      className={styles.count}
                      duration={4}
                      separator={" "}
                      end={numberOrZero(data.clientsCount)}
                    />
                  </div>
                </div>
              </Space>
            </Flex>
          </Col>
          <Col span={8} className={styles.border}>
            <Flex vertical justify="center" style={{ height: "100%", paddingLeft: 12 }}>
              <Space align="start">
                <Button
                  className={styles.labelIcon}
                  variant="filled"
                  color="geekblue"
                  icon={<AntIcon className={styles.icon} type="audit" />}
                />
                <div>
                  <Flex className={styles.labelWrapper} align="center">
                    <span className={styles.label}>{t("dashboard.statistics.contractsCount")}</span>

                    <div>
                      <TrendIndicator value={contractsStatChange} />
                    </div>
                  </Flex>
                  <div>
                    <CountUp
                      className={styles.count}
                      duration={4}
                      separator={" "}
                      end={numberOrZero(data.contractsCount)}
                    />
                  </div>
                </div>
              </Space>
            </Flex>
          </Col>
          <Col span={8}>
            <Flex vertical justify="center" style={{ height: "100%", paddingLeft: 12 }}>
              <Space align="start">
                <Button
                  className={styles.labelIcon}
                  variant="filled"
                  color="gold"
                  icon={<AntIcon className={styles.icon} type="user-switch" />}
                />
                <div>
                  <Flex className={styles.labelWrapper} align="center">
                    <span className={styles.label}>{t("dashboard.statistics.agentsCount")}</span>

                    <div>
                      <TrendIndicator value={agentsStatChange} />
                    </div>
                  </Flex>
                  <div>
                    <CountUp
                      className={styles.count}
                      duration={4}
                      separator={" "}
                      end={numberOrZero(data.agentsCount)}
                    />
                  </div>
                </div>
              </Space>
            </Flex>
          </Col>
        </Row>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Card>
  );
};
